import React from "react";
import Frame from "./Frame/Frame";

const Faculty = () => {
  return (
    <div style={{ padding: "60px" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1 style={{ position: "relative" }}>Our Faculty Council</h1>

        <div
          style={{
            width: "100%",
            maxWidth: "300px", // optional: restrict underline width
            height: "2px",
            background:
              "radial-gradient(transparent, transparent, gold, transparent, transparent)",
          }}
        ></div>
      </div>

      <div
        style={{
          marginTop: "50px",
          width: "100%",
          justifyContent: "center",
          display: "flex",
          position: "relative",
          gap: "60px",
          flexWrap: "wrap",
        }}
      >
        <Frame text={"Dr. Jyoti"}>
          <img
            src="/images/mam/jyoti_mam1.jpg"
            alt="Dr. Jyoti"
            loading="lazy"
            decoding="async"
          />
        </Frame>

        <Frame text={"Dr. Renu"}>
          <img
            src="/images/mam/renu_mam.jpg"
            alt="Dr. Renu"
            loading="lazy"
            decoding="async"
          />
        </Frame>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "40px",
        }}
      >
      </div>
    </div>
  );
};

export default Faculty;
